import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { WorkflowStatusReportsData } from './WorkflowStatusReportsData.types.tsx';

const RESOURCE_TYPE_WORKFLOW_STATUS_PROJECTS_LIMITS = 'WORKFLOW_STATUS_PROJECTS_LIMITS';

export const workflowStatusProjectsLimitsResource: RouteResource<WorkflowStatusReportsData> =
	createResource<WorkflowStatusReportsData>({
		type: RESOURCE_TYPE_WORKFLOW_STATUS_PROJECTS_LIMITS,
		getKey: () => 'workflowStatusProjectsLimits',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-workflow-status-projects-limits", jiraSpaEntry: "async-resource-workflow-status-projects-limits" */ './getWorkflowStatusData.tsx'
			),
	});
